import { PlusIcon, PencilIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import SellItemModal from '../Modal/SellItemModal'; // You can create this based on the RentItemModal

const sellItems = [
  {
    title: 'Samsung Smart TV',
    price: 100,
    deliveryMethod: 'Delivery ($4)',
    availableItems: [
      { variant: 'Black', quantity: 2 },
      { variant: 'White', quantity: 3 },
    ],
    status: 'Active',
    upcomingCustomers: [
      { name: 'Alice Johnson', purchase: 'Black TV', mode: 'Delivery' },
      { name: 'Bob Smith', purchase: 'White TV', mode: 'Delivery' },
      { name: 'Charlie Davis', purchase: 'Black TV', mode: 'Pickup' },
      { name: 'Donna Lee', purchase: 'White TV', mode: 'Delivery' }, // will be truncated
    ],
  },
  {
    title: 'iPad Mini',
    price: 350,
    deliveryMethod: 'Self-collect',
    availableItems: [
      { variant: 'Space Grey', quantity: 1 },
    ],
    status: 'Inactive',
    upcomingCustomers: [
      { name: 'Eve Carter', purchase: 'Space Grey iPad Mini', mode: 'Self-collect' },
    ],
  },
];


function SellItems() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="w-full overflow-x-auto">
        <div className="w-full flex justify-center md:block md:p-2">
          <table className="w-full md:min-w-full text-sm text-left">
           <thead className="bg-gray-800 text-gray-200 hidden md:table-header-group">
  <tr>
    <th className="px-4 py-3">Title</th>
    <th className="px-4 py-3">Price</th>
    <th className="px-4 py-3">Delivery Method</th>
    <th className="px-4 py-3">Available Items</th>
    <th className="px-4 py-3">Upcoming Customers</th> {/* New */}
  </tr>
</thead>
<tbody>
  {sellItems.map((item, idx) => (
    <tr key={idx} className="border border-gray-200 shadow-sm md:table-row block md:border-0 rounded-lg mb-4 md:mb-0 md:mx-0">
      <td className="px-4 py-3 font-semibold block md:table-cell">
        <div className="flex items-center justify-between mb-2">
          <div>
          {item.title}
          <br/>
          <span className={`inline-flex items-center text-sm font-medium ${item.status === 'Active' ? 'text-green-400' : 'text-red-400'}`}>
          <span className={`w-2 h-2 rounded-full mr-2 ${item.status === 'Active' ? 'bg-green-500' : 'bg-red-500'}`}></span>
          {item.status}
        </span>
        </div>
          <button className="text-gray-600 p-2 rounded-full">
    <PencilIcon className="w-4 h-4" />
  </button>
          </div></td>
      <td className="px-4 py-3 text-gray-300 block md:table-cell">${item.price}</td>
      <td className="px-4 py-3 block md:table-cell">{item.deliveryMethod}</td>
      <td className="px-4 py-3 block md:table-cell">
        {item.availableItems.map((variant, i) => (
          <div key={i}>
            <span className="font-medium">{variant.variant}</span>: {variant.quantity} left
          </div>
        ))}
      </td>
      <td className="px-4 py-3 block md:table-cell">
        {item.upcomingCustomers.slice(0, 3).map((cust, i) => (
          <div key={i} className="mb-1">
            <span className="font-semibold">{cust.name}</span>: {cust.purchase} ({cust.mode})
          </div>
        ))}
        {item.upcomingCustomers.length > 3 && (
          <div className="text-xs text-gray-400">+{item.upcomingCustomers.length - 3} more</div>
        )}
      </td>
      
    </tr>
  ))}
</tbody>

          </table>
        </div>
      </div>

      
    </>
  );
}

export default SellItems;
